export const ROUTES_LOCATIONS_ROOT = '/locations'
export const API_SINGLE_LOCATION = '/location/:locationId'

export const makeSingleLocationRequestRoute = locationId => {
  return API_SINGLE_LOCATION.replace(':locationId', locationId)
}
